import { Skeleton } from '@/components/ui/skeleton';
import { PendingRegion } from '@/shared/components/PendingRegion';
import { OVERVIEW_GRID, OVERVIEW_MAIN_COLUMN } from '../overviewLayout';

/**
 * The overview while it loads (spec 079 US2).
 *
 * On the page's own grid, imported rather than restated, so the two columns and the
 * rail's width cannot drift from the content that replaces them (FR-016).
 *
 * The blocks stand for sections, not for their contents: two lists on the left, three
 * describing panels on the right. What is deliberately *not* drawn is any of the text,
 * counts or icons inside them — a placeholder that draws content is a small lie that has
 * to be maintained, and it is the thing that makes a skeleton look broken when the real
 * section turns out to have four rows rather than three (FR-015).
 */
export function OverviewSkeleton() {
  return (
    <PendingRegion label="Loading this workspace">
      <div className={OVERVIEW_GRID}>
        <div className={OVERVIEW_MAIN_COLUMN}>
          <Skeleton className="h-44 w-full" />
          <Skeleton className="h-36 w-full" />
        </div>
        <div className="flex flex-col gap-5">
          <Skeleton className="h-40 w-full" />
          <Skeleton className="h-24 w-full" />
        </div>
      </div>
    </PendingRegion>
  );
}
